import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges
} from "@angular/core";
import { MatDialog, MatSnackBar } from "@angular/material";
import { DialogService, DossierService, FormulaireService, TiersService } from "../../../../../services";
import { Tiers } from "../../../../../Interfaces/Tiers";
import {
    RechercheTiersDialogComponent
} from "../../../layout/dialogs/recherche-tiers-dialog/recherche-tiers-dialog.component";
import { fadeHeightAnimation } from "../../../../pages/nouveau/nouveau-animation";
import {
    FormDialogFormulaireWithSFComponent
} from "../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component";
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'

@Component({
    selector: "atyl-nouveau-form",
    templateUrl: "./nouveau-form.component.html",
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: [ "./nouveau-form.component.scss" ],
    animations: [ fadeHeightAnimation ]
})
export class NouveauFormComponent implements OnInit, OnChanges {
    @Input() form: any;

    @Input() membres: Tiers[] = [];
    relationsTiers: any = {};
    idMembresWithFormCreated: number[] = [];
    idFormOf = {
        "USAGER": null,
        "ENFANT": null,
        "FOYER": null
    }
    loadingDossierIds: number[] = [];

    disableMembre:boolean[]=[];
    formMembre:any[]=[];
    
    constructor(
        private dialogInputTier: MatDialog,
        private snackBar: MatSnackBar,
        private changeDetectorRef: ChangeDetectorRef,
        private dialogService: DialogService,
        private dossierService: DossierService,
        private tiersService: TiersService,
        private formulaireService: FormulaireService
    ) {
    }

    /**
     * Si le formulaire change on réinitialise les tiers sélectionnés
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.form.currentValue != changes.form.previousValue) {
            this.membres = [];
            this.relationsTiers = {}
            this.disableMembre=[];
            this.formMembre=[];
        }
    }

    ngOnInit() {
        this.formulaireService.listByCode([ "ENFANT", "MEMBRE", "FOYER" ], [])
            .subscribe(res => {
                this.idFormOf.ENFANT = res.result.ENFANT.ID;
                this.idFormOf.USAGER = res.result.MEMBRE.ID;
                this.idFormOf.FOYER = res.result.FOYER.ID;
            }, (e) => this.errorFunction());
    }

    /**
     * Désélectionne un tiers - supprime un tiers de la liste sélectionné.
     *
     * @param id id de tiers
     */
    deselectTier(id: number) {
        this.membres = this.membres.filter(t => t.ID != id);
        this.idMembresWithFormCreated = this.idMembresWithFormCreated.filter(i => i != id);
        delete this.relationsTiers[id];
    }

    /**
     * Ouvre le dialog de recherche de membre.
     */
    dialogMembre() {
        const dialogTierRef = this.dialogInputTier.open(RechercheTiersDialogComponent, {
            width: 'max(600px, 60%)',
            data: {
                selected: this.membres,
                typeTier: this.form.tiers_type[0].type.code,
                formid:	this.idFormOf,
                titreColonnes: [
                    {
                        titre: 'Nom',
                        columnKey: 'NOM',
                        columnRef: 'nom'
                    },
                    {
                        titre: 'Nom marital',
                        columnKey: 'NOMMARITAL',
                        columnRef: 'nom-marital'
                    },
                    {
                        titre: 'Prenom',
                        columnKey: 'PRENOM',
                        columnRef: 'prenom'
                    },
                    {
                        titre: 'Date de naissance',
                        columnKey: 'DATENAISSANCE',
                        columnRef: 'date',
                        type: 'date'
                    },
                ]
            },
        });
        dialogTierRef.afterClosed().subscribe((d) => {
            if (d && d.mode == 1) {
                this.membres = d.selected;
                this.disableMembre=[];
                this.formMembre=[];
                
                console.log('dialogTierRef afterClosed  ',this.membres);
                
                for (let i = 0; i < this.membres.length; i++) {
                    if (!this.membres[i].dossierID) continue;
 					this.disableMembre.push(true);
 					this.formMembre.push({});
                    this.loadingDossierIds.push(this.membres[i].ID);
                    this.dossierService.get(this.membres[i].dossierID)
                        .subscribe((res) => {
                            if (res.result != undefined && res.result) {
                                this.membres[i].dossier = res.result;
                                this.listRelationTiers(this.membres[i]);
                                console.log("dossierService.get",res.result);
                                if (res.result.ID!=undefined && res.result.tiers!=undefined
                                 && res.result.tiers.type!=undefined
                                ) {
			
									let formID:any='ENFANT'==res.result.tiers.type? this.idFormOf.ENFANT
						              
						                                        : this.idFormOf.USAGER;
						                                        
						            console.log("getformulairelist.get 0",formID);
						            if (formID>0) {
							             let _opts:any={
								            formid: formID
								
										}                           
							            console.log("getformulairelist call",res.result.ID,_opts);                      
							            this.dossierService.getformulairelist(res.result.ID,_opts).subscribe((res: JSONRpcResponse) => {
							                            console.log("getformulairelist",res)
							                            if (res.result && res.result.length>0 ) {
																
																this.disableMembre[i]=false;
																this.formMembre[i]=res.result[0];
																this.changeDetectorRef.detectChanges();
														}
							                            
							                        });
							       }            
						                                                  
								}
                                
                                
                                
                                
                            } else {
                                this.errorFunction();
                            }
                        }, (e) => this.errorFunction())
                        .add(() => {
                            this.loadingDossierIds.splice(this.loadingDossierIds.indexOf(this.membres[i].ID), 1);
                            this.changeDetectorRef.detectChanges();
                        });
                }
                this.changeDetectorRef.detectChanges();
            }
        }, (e) => this.errorFunction());
    }

    /**
     * Ouvre le dialog de recherche de foyer.
     *
     * @param membre
     */
    dialogFoyer(membre: Tiers) {
        let options = {
            width: 'max(600px, 60%)',
            data: {
                typeTier: 'FOYER',
                formid:	this.idFormOf,
                titreColonnes: [
                    {
                        titre: 'Foyer',
                        columnKey: 'NOM',
                        columnRef: "nom"
                    },
                    {
                        titre: 'Adresse',
                        columnKey: [ 'number', 'street' ],
                        columnRef: "adresse",
                        type: 'adresse-principale'
                    },
                    {
                        titre: 'Ville',
                        columnKey: 'town',
                        columnRef: "ville",
                        type: 'adresse-principale'
                    },
                    {
                        titre: 'Code Postal',
                        columnKey: 'IDzipcode',
                        columnRef: "code-postal",
                        type: 'adresse-principale'
                    },
                ]
            }
        }
        let dialogTierRef = this.dialogInputTier.open(RechercheTiersDialogComponent, options);

        dialogTierRef.afterClosed().subscribe((d) => {
            if (d && d.mode == 1) {
                for (let i = 0; i < d.selected.length; i++) {
                    this.loadingDossierIds.push(membre.ID);
                    this.changeDetectorRef.detectChanges();
                    this.tiersService.setRelation({
                        IdTiers1: d.selected[i].ID,
                        IdTiers2: membre.ID,
                        type: "FOYER"
                    }).subscribe(
                        (r) => {
                            this.snackBar.open('Foyer(s) enregistré(s)', undefined, { duration: 5000 })
                            this.dossierService.get(membre.dossierID).subscribe(res => {
                                membre.dossier.foyers = res.result.foyers;
                            }, (e) => this.errorFunction()).add(() => {
                                this.loadingDossierIds.splice(this.loadingDossierIds.indexOf(membre.ID), 1);
                                this.changeDetectorRef.detectChanges();
                            })
                        },
                        (e) => this.errorFunction()
                    );
                }
            } else if (d && d.mode == 2) {
                this.dialogForm(this.idFormOf.FOYER, undefined, () => {
                    this.dialogFoyer(membre);
                });
            }
        }, (e) => this.errorFunction());
    }

    /**
     * Formate les libellés des relations et les ajoutes dans la liste des relations.
     *
     * @param tiers
     */
    listRelationTiers(tiers: Tiers) {
        let relations = tiers.dossier;
        let listeRelation = [];

        for (let i = 0; i < relations.relations.to.length; i++) {
            let relation = { ...relations.relations.to[i] };
            listeRelation.push(relation);
        }

        for (let i = 0; i < relations.relations.from.length; i++) {
            let relation = { ...relations.relations.from[i] };
            relation.relation.libelle = relation.relation.libelle + " de";
            listeRelation.push(relation);
        }

        this.relationsTiers[tiers.ID] = listeRelation;
        this.changeDetectorRef.detectChanges();
    }

    /**
     * ouvre un dialog d'un formulaire
     *
     * @param idForm id de formulaire
     * @param tiers le tiers ayant un dossier pour pouvoir préremplir le formulaire
     * @param afterClosed la fonction après la fermeture de dialog
     */
    dialogForm(idForm: number, tiers?: Tiers, afterClosed?: Function) {
        let data = {
            idAForm: idForm,
            create: true,
            closeWhenValidate: true,
            v3: true,
        }
        console.log('tiers:',tiers);
        if (tiers) {
            data['dossier'] = tiers['dossier'];
        }
        this.dialogService.open(FormDialogFormulaireWithSFComponent, {
            data: data,
            height: "90vh",
            width: "90vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, () => {
            if (afterClosed) {
                let fun = afterClosed.bind(this);
                fun(tiers);
            }
        })
    }

    /**
     * Désélectionner tous les membres sélectionnés.
     */
    deselectAll() {
        this.membres = [];
        this.idMembresWithFormCreated = [];
        this.relationsTiers = {};
    }

    /**
     * Ouvre le dialog de recherche de membre si on entre un caractère alphanumérique.
     *
     * @param ev
     */
    onInput(ev: KeyboardEvent) {
        const key = ev.key.toLowerCase();

        if (ev.key.length != 1) {
            return;
        }

        const isLettre = ( key >= 'a' && key <= 'z' );
        const isNumber = ( key >= '0' && key <= '9' );

        if (isLettre || isNumber) {
            this.dialogMembre();
        }
    }

    /**
     * Ajoute l'id d'un membre dans la liste des membres pour
     * lesquelles on a déjà créé un formulaire.
     *
     * @param membre
     */
    formAddedFor(membre: Tiers) {
        this.idMembresWithFormCreated.push(membre.ID);
        this.changeDetectorRef.detectChanges();
    }

    /**
     * Affiche une erreur
     */
    errorFunction() {
        this.snackBar.open('Une erreur est survenue', undefined, { duration: 5000 });
    }

    addFoyerToolTip(foyer: any) {
        let str = ""
        if (foyer.adresses) {
            let adresses = foyer.adresses;
            if (adresses.PRINCIPALE) {
                let adrPrincipale = adresses.PRINCIPALE;
                if (adrPrincipale.number) {
                    str += adrPrincipale.number + " ";
                }
                if (adrPrincipale.complement) {
                    str += adrPrincipale.complement + " ";
                }
                if (adrPrincipale.street) {
                    str += adrPrincipale.street + " ";
                }
                if (adrPrincipale.town) {
                    str += adrPrincipale.town;
                }
            }
        }
        return str;
    }
    
    isFindMembre(membre:any) {
		let disabled:boolean=true;
		console.log('isFindMembre',membre);
		
		
		
	    return disabled;
	}

    dialogFormUser(idx:number, membre:Tiers) {
	   console.log("formMembre:",this.formMembre);
		if (this.formMembre[idx]!=undefined 
		&& this.formMembre[idx].ID !=undefined ) {
			
			let form=this.formMembre[idx].form;
			
			let demandeForm = this.formMembre[idx]
			
				let datasF = {
					title: form.libelle,
					id: demandeForm.ID,
					formType: demandeForm.key,
					idDemandeForm: form.ID,
				}
				datasF['dossier'] = membre.dossier;
	           datasF['isEditable'] = true;
	           	
				this.dialogService.open(FormDialogFormulaireWithSFComponent, {
					data: datasF,
					height: '90vh',
					width: "90vw",
					resizable: true,
					minimizable: true,
					draggable: true,
					maximizable: true,
				}, () => {
	           
	                this.dossierService.get(membre.dossier.ID)
                    .subscribe((res) => {
                        if (res.result != undefined && res.result) {
                            this.membres[idx].dossier = res.result;
                            this.listRelationTiers(this.membres[idx]);
                            console.log("dossierService.get",res.result);        
                            this.membres[idx]=res.result.tiers;                                           
                            this.changeDetectorRef.detectChanges();
                        } else {
                            this.errorFunction();
                        }
                    }, (e) => this.errorFunction())
                    .add(() => {
                        this.loadingDossierIds.splice(this.loadingDossierIds.indexOf(this.membres[idx].ID), 1);
                        this.changeDetectorRef.detectChanges();
                    });
	        });
		}
	}

}
